export default __webpack_public_path__ + "static/media/booking.cd9451c9.svg";